import React, { useState } from "react";

export default function TagsCell({ value, readOnly, onCommit }) {
  const tags = Array.isArray(value) ? value : [];
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState("");

  const submit = () => {
    const t = draft.trim();
    if (!t) {
      setAdding(false);
      return;
    }
    if (tags.includes(t)) {
      setDraft("");
      return;
    }
    onCommit([...tags, t]);
    setDraft("");
  };

  const remove = (t) => {
    const next = tags.filter((x) => x !== t);
    onCommit(next.length ? next : null);
  };

  return (
    <div className="cell-display tags">
      {tags.map((t) => (
        <span key={t} className="tag-chip">
          {t}
          {!readOnly && (
            <button className="tag-chip-x" onClick={() => remove(t)} title="Remove">×</button>
          )}
        </span>
      ))}
      {!readOnly && (
        adding ? (
          <input
            autoFocus
            className="tag-input"
            value={draft}
            placeholder="tag"
            onChange={(e) => setDraft(e.target.value)}
            onBlur={() => {
              submit();
              setAdding(false);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") submit();
              if (e.key === "Escape") {
                setDraft("");
                setAdding(false);
              }
            }}
          />
        ) : (
          <button className="tag-add" onClick={() => setAdding(true)}>+</button>
        )
      )}
      {readOnly && tags.length === 0 && <span className="placeholder">—</span>}
    </div>
  );
}
